var map = {
	"./carousel/babylon-berlin.jpg": "608d",
	"./carousel/kaenguru-chroniken.jpg": "dc6c",
	"./carousel/sz-cinemathek.jpg": "7913",
	"./logo-studio57.svg": "9fcc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";